import { Box, Flex, useToast } from "@chakra-ui/react";
import React, { Children, cloneElement, isValidElement } from "react";
import { useNavigate } from 'react-router-dom';

import { MobileTopBar } from "@components/MobileTopBar/MobileTopBar";
import { Sidebar } from "@components/Sidebar/Sidebar";
import { config } from "@/config/config";
import { useAuthContext } from "@hooks/useAuthContext";
import { useColorContext } from "@hooks/useColorContext";
import { logout } from "@services/authentication.service";
import { $g1Color } from "@/theme/G1Style";
import { isAdminUser } from "@utils/functions";
import { defaultErrorToast } from "@utils/toast";

type AuhenticatedLayoutProps = {
    children: React.ReactNode ;
    adminPage?: boolean;
    searchPage?: boolean;
    activeMenuItem?: string;
};

export const AuthenticatedLayout = (props: AuhenticatedLayoutProps) => {
    const { children, adminPage, searchPage, activeMenuItem } = props;
    const { isAuthenticated, isUserAuthenticated, isAdminAuthenticated, connectedUser, disconnect } = useAuthContext();
    const toast = useToast();
    const navigate = useNavigate();

    if (!isAuthenticated) {
        toast(defaultErrorToast("Vous n'êtes pas autorisé à accéder à cette page"));
        disconnect();
        navigate(adminPage ? config.admin.loginURL! : config.app.loginURL!);
    } else if (!!adminPage && (isUserAuthenticated || (isAdminAuthenticated && !isAdminUser(connectedUser?.userFlags?.profile)))) {
        toast(defaultErrorToast("Veuillez vous connecter en tant qu'administrateur"));
        disconnect();
        logout();
        navigate(adminPage ? config.admin.loginURL! : config.app.loginURL!);
    }

    const enhancedChildren = Children.map(children, child => {
        if (isValidElement(child)) {
            return cloneElement(child, { connectedUser }) ;
        }
        return child ;
    }) ;

    const handleSearch = (searchString: string) => {
        navigate("/app/search", { state: { search: searchString } }) ;
    } ;

    useColorContext() ;
    return (
        <Box as="section" bg={$g1Color('global.bg')} px="0" py="0">
            <Box px={{ base: "0" }}>
                <Flex h="100vh" flexDirection="column">
                    <MobileTopBar activeItemKey={activeMenuItem} adminPage={adminPage} onSearch={handleSearch} />
                    <Flex flex="1" overflow="hidden">
                        <Sidebar
                            minW="20%"
                            display={{ base: "none", md: "flex" }}
                            activeItemKey={activeMenuItem}
                            onSearch={handleSearch}
                            activesearch={searchPage}
                            adminPage={adminPage}
                        />
                        {enhancedChildren}
                    </Flex>
                </Flex>
            </Box>
        </Box>
    ) ;
} ;